"use strict";
exports.__esModule = true;
exports.getBpMonth = exports.getPauseDate = exports.getPauseMonth = exports.renderRentBillDueMonth = exports.formatBillDate = exports.getNextBillCycleMonth = exports.getResumeDate = exports.isAfterOnboardingCutoff = void 0;
var luxon_1 = require("luxon");
var date_1 = require("./date");
var autopayCutOffDay = 4;
var autopayCutOffHour = 17;
var isAfterOnboardingCutoff = function (today) {
    var currentDate = today.setZone('America/New_York');
    // Resume date cutoff for the current month is 5pm America/New_York (EST) on the 4th
    var cutoffDate = currentDate.set({
        day: autopayCutOffDay,
        hour: autopayCutOffHour,
        minute: 0,
        second: 0,
        millisecond: 0
    });
    return currentDate >= cutoffDate;
};
exports.isAfterOnboardingCutoff = isAfterOnboardingCutoff;
var getResumeDate = function (today) {
    if ((0, exports.isAfterOnboardingCutoff)(today)) {
        return today.set({ month: today.month + 1, day: autopayCutOffDay });
    }
    else {
        return today.set({ day: autopayCutOffDay });
    }
};
exports.getResumeDate = getResumeDate;
var getNextBillCycleMonth = function (currentBPEndDate) {
    return (0, date_1.getDateTimeFromISO)(currentBPEndDate);
};
exports.getNextBillCycleMonth = getNextBillCycleMonth;
var formatBillDate = function (date, monthOnly) {
    if (!date) {
        return '';
    }
    if (monthOnly) {
        return "".concat(date.monthLong);
    }
    else {
        return "".concat(date.monthLong, " ").concat(date.year);
    }
};
exports.formatBillDate = formatBillDate;
var renderRentBillDueMonth = function (today) {
    var billDueMonth = today;
    var currentDay = today;
    var endOfMonth = today.endOf('month');
    var pauseCutOffForCurrentMonth = endOfMonth.minus({ day: 2 });
    if (currentDay.day !== 1) {
        if (currentDay.day >= pauseCutOffForCurrentMonth.day) {
            billDueMonth = billDueMonth.plus({ month: 2 });
        }
        else {
            billDueMonth = billDueMonth.plus({ month: 1 });
        }
    }
    return billDueMonth.monthLong;
};
exports.renderRentBillDueMonth = renderRentBillDueMonth;
var getPauseMonth = function (today) {
    var pauseCutoff;
    var endOfMonth = today.endOf('month');
    var nextMonth = today.plus({ month: 1 }).set({ day: 1 });
    var monthAfterNext = today.plus({ month: 2 }).set({ day: 1 });
    if (today.day < endOfMonth.day - 1) {
        pauseCutoff = nextMonth.set({ day: nextMonth.daysInMonth - 1 });
    }
    else {
        pauseCutoff = monthAfterNext.set({ day: monthAfterNext.daysInMonth - 1 });
    }
    return pauseCutoff;
};
exports.getPauseMonth = getPauseMonth;
var getPauseDate = function (today) {
    var pauseCutoff;
    var endOfMonth = today.endOf('month');
    if (today.day < endOfMonth.day - 1) {
        pauseCutoff = today.set({ day: endOfMonth.day - 1 });
    }
    else {
        var nextMonth = today.plus({ month: 1 }).set({ day: 1 });
        pauseCutoff = nextMonth.set({ day: nextMonth.daysInMonth - 1 });
    }
    return pauseCutoff;
};
exports.getPauseDate = getPauseDate;
var getBpMonth = function (bpEndDate) {
    var _a;
    var bpMonth = bpEndDate ? (_a = luxon_1.DateTime.fromFormat(bpEndDate, 'yyyy-MM-dd')) === null || _a === void 0 ? void 0 : _a.monthLong : '';
    return bpMonth || '';
};
exports.getBpMonth = getBpMonth;
